import { HTMLAttributes, ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
  fade?: boolean;
  isOpen?: boolean;
  toggle?: () => void;
  children?: ReactNode;
}

export function Alert({ color = 'success', fade, isOpen = true, toggle, className, children, ...props }: AlertProps) {
  if (!isOpen) return null;
  return (
    <div role="alert" className={classnames('alert', color && `alert-${color}`, toggle && 'alert-dismissible', className)} {...props}>
      {children}
      {toggle && <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />}
    </div>
  );
}
